import { Col, Row } from "@intech/web-ui";
import styled from "styled-components";

export const GreenColumn = styled.div`
  align-self: center;
  color: #fff;
  background-color: #28a745;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`;

export const ResultadoRow = styled(Row)`
  border-bottom: 1px solid black;
  margin-top: 5px;
  padding-bottom: 5px;
  font-size: 12px;
`;

export const CenteredColumn = styled(Col)`
  justify-content: center;
  align-self: center;
`;

export const LeftColumn = styled(Col)`
  justify-content: left;
  align-self: center;
`;
